var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mc-request-detail"},[_c('PageHeader',{staticClass:"mc-request-detail__page-header",attrs:{"title":_vm.title},scopedSlots:_vm._u([{key:"afterTitle",fn:function(){return [_c('ActionButtons')]},proxy:true}])}),_c('BasicInfoDetail',{attrs:{"showResponse":_vm.showResponse}}),_c('LoadDetail')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }